//
export default [
    {
        name: 'family',
        props: {
            label: 'Familia',
        },
        flex: {
            sm6: true,
            lg6: true,
        },
        type: 'text-field',
    },
]
